export const getSortedTrendingCountries = (countries: any[]) => {
  return countries
    .filter((c: any) => c?.is_trending)
    .sort(
      (a: any, b: any) => (b?.trending_score ?? 0) - (a?.trending_score ?? 0)
    );
};
